import Service, { service } from "@ember/service";
import type SemeiaSessionService from "./session";

export type Issuer = "pro-sante-connect" | "aphp-medic";

export default abstract class OpenIdConnectService extends Service {
  @service declare session: SemeiaSessionService;

  abstract label: string;
  abstract imageUrl: string;
  abstract issuer: Issuer;
  declare route: string;
  abstract get isEnabled(): boolean;
}
